module.exports = __webpack_public_path__ + "static/media/10.51101cc9.jpg";